import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import Root from "./root.component";

const rootElementId = "root";
let rootElement = document.getElementById(rootElementId);

if (!rootElement) {
  rootElement = document.createElement("div");
  rootElement.id = rootElementId;
  document.body.appendChild(rootElement);
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
	<Root />
  </React.StrictMode>
);

